import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgNebulaUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 260 270",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3699_717)",
		filter: "url(#filter0_f_3699_717)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M157 12.1098C154.14 13.1898 151.29 14.3598 148 15.1098C117.65 22.0598 105.48 35.0098 74 32.1098C72.12 32.1198 68.03 32.1198 68 32.1098C63.61 31.7398 57.83 31.6198 53 32.1098C51.32 32.9798 50.42 36.6698 52 35.1098C79.14 29.4898 104.74 47.3498 129.22 26.3298C153.7 5.3198 174.66 25.2098 192 39.1098C192.48 39.0198 193 39.1098 193 39.1098C194.27 37.8898 192.77 35.7098 192 34.1098C185.54 23.7198 175.76 17.1198 167 9.1098C163.7 10.2098 160.34 11.1898 157 12.1098Z",
				fill: "#00D9FA",
				fillOpacity: .09
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M148 15.1098C151.29 14.3598 154.14 13.1898 157 12.1098C153.9 12.9598 150.76 14.2098 148 15.1098Z",
				fill: "#00FFFF",
				fillOpacity: .01
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M52 35.1098C49.79 35.5698 47.01 38.1798 45 39.1098C48.2 38.6798 51.76 39.1098 55 39.1098C67.64 39.1098 81.12 41.5098 93 41.1098C96.12 39.2798 101.39 40.1098 105 40.1098C124.03 36.6998 144.27 19.6698 159 43.1098C161.64 40.6698 165.75 41.1398 166 44.1098C173.69 39.9598 181.66 41.8798 190 40.1098C190.81 39.9398 191.15 39.2698 192 39.1098C174.66 25.2098 153.7 5.3198 129.22 26.3298C104.74 47.3498 79.14 29.4898 52 35.1098Z",
				fill: "#00DCFF",
				fillOpacity: .26
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M105 40.1098C106.67 40.1098 108.33 40.1098 110 40.1098C130.63 36.1598 149.81 45.5298 162 66.1098C149.61 63.3098 136.88 59.5598 125 56.1098C123.91 56.1798 122.47 57.0598 122 57.1098C125.13 58.2098 127.99 59.6598 131 61.1098C131.67 61.2398 134.37 60.7598 136 61.1098C156.15 65.4898 174.46 78.6898 192 89.1098C191.08 84.4398 190.57 79.6098 189 75.1098C183.1 70.2698 178 64.9598 171 62.1098C174.96 61.0998 177.68 66.7498 181 65.1098C174.89 61.8498 168.71 57.1798 162 55.1098C162.63 52.3898 159.93 50.6998 160 48.1098C162.07 47.4198 164.09 45.4798 166 44.1098C165.75 41.1398 161.64 40.6698 159 43.1098C144.27 19.6698 124.03 36.6998 105 40.1098Z",
				fill: "#00E0FF",
				fillOpacity: .36
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M38 35.1098C35.78 36.5298 34.25 40.2698 31 40.1098C31.57 41.0498 32.15 41.9298 32 43.1098C34.19 42.0898 36.71 41.8598 39 41.1098C40.88 40.4898 43.24 39.9298 45 39.1098C47.01 38.1798 49.79 35.5698 52 35.1098C50.42 36.6698 51.32 32.9798 53 32.1098C47.45 32.6698 43.05 32.8798 38 35.1098Z",
				fill: "#00B7FC",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M74 32.1098C72.02 31.9298 69.99 32.2798 68 32.1098C68.03 32.1198 72.12 32.1198 74 32.1098Z",
				fill: "#00AFFF",
				fillOpacity: .02
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M193 39.1098C193.52 42.2798 195.09 41.5798 197 43.1098C196.42 42.0498 196.48 40.2598 196 39.1098C195.13 37.0398 193.21 35.7398 192 34.1098C192.77 35.7098 194.27 37.8898 193 39.1098Z",
				fill: "#04A3FE",
				fillOpacity: .11
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11 69.1098C13.32 64.6698 17.02 59.4598 20 55.1098C23.16 50.5098 26.85 45.5198 32 43.1098C32.15 41.9298 31.57 41.0498 31 40.1098C34.25 40.2698 35.78 36.5298 38 35.1098C24.92 40.8898 15.44 56.4598 11 69.1098Z",
				fill: "#0090FE",
				fillOpacity: .13
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M110 40.1098C125.98 40.1098 141.69 47.0798 151 60.1098C142.25 59.1598 133.89 56.6098 125 56.1098C136.88 59.5598 149.61 63.3098 162 66.1098C149.81 45.5298 130.63 36.1598 110 40.1098Z",
				fill: "#00E2FF",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M38.9999 41.1098C34.9699 43.2398 31.8899 47.3298 27.9999 50.1098C29.7199 50.2598 29.9199 50.5798 28.9999 52.1098C30.1099 53.0098 31.7399 50.2498 32.9999 51.1098C24.8299 68.0998 12.6299 89.6898 23.9999 108.11C25.1099 109.61 27.1699 110.49 27.9999 112.11C28.7399 112.37 30.2099 112.11 30.9999 112.11C30.4899 111.86 30.3199 110.45 29.9999 110.11C25.9699 105.79 27.2599 107.39 27.9999 102.11C30.6099 83.4498 36.9899 56.1498 45.9999 46.1098C49.0699 46.8198 52.3799 42.5198 50.9999 40.1098C52.2799 39.8298 54.4999 40.8698 54.9999 39.1098C51.7599 39.1098 48.1999 38.6798 44.9999 39.1098C43.2399 39.9298 40.8799 40.4898 38.9999 41.1098Z",
				fill: "#00BFFF",
				fillOpacity: .36
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28 102.11C38.4 87.4898 61.91 68.8498 78 63.1098C78.08 62.6198 78 62.1098 78 62.1098C77.5 62.1098 76.49 62.0298 76 62.1098C64.25 67.8698 53.12 75.8998 42 83.1098C47.83 61.3898 65.55 36.8398 92 42.1098C92.3 41.8898 92.73 41.2698 93 41.1098C81.12 41.5098 67.64 39.1098 55 39.1098C54.5 40.8698 52.28 39.8298 51 40.1098C52.38 42.5198 49.07 46.8198 46 46.1098C36.99 56.1498 30.61 83.4498 28 102.11Z",
				fill: "#00D3FF",
				fillOpacity: .38
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M190 40.1098C190.08 39.8998 192.06 44.1898 192 44.1098C193.5 46.0498 196.27 46.6598 198 48.1098C198.04 48.2898 198.97 45.8798 199 46.1098C198.73 44.2498 198.35 44.1898 197 43.1098C195.09 41.5798 193.52 42.2798 193 39.1098C193 39.1098 192.48 39.0198 192 39.1098C191.15 39.2698 190.81 39.9398 190 40.1098Z",
				fill: "#10A0FF",
				fillOpacity: .32
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M197 43.1098C198.35 44.1898 198.73 44.2498 199 46.1098C203 51.2098 219.6 56.8998 226 61.1098C218.56 51.5498 205.98 46.8398 196 39.1098C196.48 40.2598 196.42 42.0498 197 43.1098Z",
				fill: "#1575FA",
				fillOpacity: .16
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M93 41.1098C92.73 41.2698 92.3 41.8898 92 42.1098C79.88 51.0398 52.07 51.7398 50 75.1098C58.21 69.7198 66.67 64.9998 76 62.1098C76.49 62.0298 77.5 62.1098 78 62.1098C78.5 62.1098 79 62.1098 79 62.1098C80.42 61.5098 81.74 59.8698 83 59.1098C73.79 61.8098 64.79 65.0998 56 69.1098C72.47 38.1898 117.28 34.0898 143 55.1098C135.05 57.5298 124.16 51.6398 116 55.1098C118 55.5698 120.04 56.4198 122 57.1098C122.47 57.0598 123.91 56.1798 125 56.1098C133.89 56.6098 142.25 59.1598 151 60.1098C141.69 47.0798 125.98 40.1098 110 40.1098C108.33 40.1098 106.67 40.1098 105 40.1098C101.39 40.1098 96.12 39.2798 93 41.1098Z",
				fill: "#00E0FF",
				fillOpacity: .56
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M166 44.1098C164.09 45.4798 162.07 47.4198 160 48.1098C159.93 50.6998 162.63 52.3898 162 55.1098C168.71 57.1798 174.89 61.8498 181 65.1098C189.65 69.7298 195.9 81.3098 205 85.1098C205 84.6098 205 84.1098 205 84.1098C205 82.7798 205 81.4398 205 80.1098C201.37 69.3998 189.95 63.3798 177.25 57.8598C164.55 52.3398 173.13 39.0698 192 44.1098C192.06 44.1898 190.08 39.8998 190 40.1098C181.66 41.8798 173.69 39.9598 166 44.1098Z",
				fill: "#08BCFF",
				fillOpacity: .43
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32 43.1098C26.85 45.5198 23.16 50.5098 20 55.1098C22.29 52.6798 25.59 51.8298 28 50.1098C31.89 47.3298 34.97 43.2398 39 41.1098C36.71 41.8598 34.19 42.0898 32 43.1098Z",
				fill: "#00A6FF",
				fillOpacity: .28
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M76 62.1098C66.67 64.9998 58.21 69.7198 50 75.1098C52.07 51.7398 79.88 51.0398 92 42.1098C65.55 36.8398 47.83 61.3898 42 83.1098C53.12 75.8998 64.25 67.8698 76 62.1098Z",
				fill: "#00DBFF",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M83 59.1098C84.17 58.7698 84.68 58.2398 86 58.1098C89.24 57.7798 90.75 55.4798 96 55.1098C95.92 55.0998 95.77 53.2698 96 53.1098C89.26 55.4998 79.32 54.6998 73 54.1098C75.93 52.8298 78.3 50.7498 81 49.1098C92.56 43.4498 106.4 41.8898 119 45.1098C122.83 46.0898 126.46 47.5298 130 49.1098C119.88 51.9498 107.3 51.2098 97 53.1098C99.5 52.8298 97.89 54.6298 99 55.1098C104.65 54.0498 110.29 53.7998 116 55.1098C124.16 51.6398 135.05 57.5298 143 55.1098C117.28 34.0898 72.47 38.1898 56 69.1098C64.79 65.0998 73.79 61.8098 83 59.1098Z",
				fill: "#00E1FF",
				fillOpacity: .7
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M81 49.1098C89.13 48.6398 107.7 46.1398 119 45.1098C106.4 41.8898 92.56 43.4498 81 49.1098Z",
				fill: "#00E2FF",
				fillOpacity: .98
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M205 80.1098C205 74.4398 205 68.7798 205 63.1098C205 62.6098 205.05 61.5998 205 61.1098C204.96 60.6998 202.04 50.9098 203 54.1098C201.1 52.8298 199.71 49.5498 198 48.1098C196.27 46.6598 193.5 46.0498 192 44.1098C173.13 39.0698 164.55 52.3398 177.25 57.8598C189.95 63.3798 201.37 69.3998 205 80.1098Z",
				fill: "#0EA9FF",
				fillOpacity: .49
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M81 49.1098C78.3 50.7498 75.93 52.8298 73 54.1098C79.32 54.6998 89.26 55.4998 96 53.1098C96.44 52.9498 97 53.1098 97 53.1098C107.3 51.2098 119.88 51.9498 130 49.1098C126.46 47.5298 122.83 46.0898 119 45.1098C107.7 46.1398 89.13 48.6398 81 49.1098Z",
				fill: "#00E3FF",
				fillOpacity: .9
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M198 48.1098C199.71 49.5498 201.1 52.8298 203 54.1098C212.42 60.4398 223.5 63.4298 233 71.1098C231.34 68.5798 230.21 63.8798 226 61.1098C219.6 56.8998 203 51.2098 199 46.1098C198.97 45.8798 198.04 48.2898 198 48.1098Z",
				fill: "#1473F8",
				fillOpacity: .36
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20 55.1098C17.02 59.4598 13.32 64.6698 11 69.1098C8.52 76.1798 7 83.3898 7 91.1098C7 97.1098 7 103.11 7 109.11C7 119.86 10.83 131.81 14 140.11C14.16 139.06 14.87 138.32 15 137.11C15.97 128.36 9.19 119.42 9 110.11C7.03 93.8298 9.25 76.7598 19 63.1098C21.73 59.2798 26.97 55.4798 29 52.1098C29.92 50.5798 29.72 50.2598 28 50.1098C25.59 51.8298 22.29 52.6798 20 55.1098Z",
				fill: "#1080FE",
				fillOpacity: .44
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.0001 52.1098C26.9701 55.4798 21.7301 59.2798 19.0001 63.1098C20.5201 61.9198 24.4801 62.0698 26.0001 60.1098C24.2501 64.7798 22.3301 69.9498 20.0001 74.1098C19.2601 76.2898 18.2101 80.2698 18.0001 82.1098C17.7801 84.0498 18.0001 86.1498 18.0001 88.1098C18.0001 98.0598 21.2101 105.47 23.0001 114.11C23.1801 112.54 24.3801 110.4 24.0001 108.11C12.6301 89.6898 24.8301 68.0998 33.0001 51.1098C31.7401 50.2498 30.1101 53.0098 29.0001 52.1098Z",
				fill: "#00A5FF",
				fillOpacity: .51
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M96.0001 55.1098C96.9601 55.0398 98.0501 55.2898 99.0001 55.1098C97.8901 54.6298 99.5001 52.8298 97.0001 53.1098C97.0001 53.1098 96.4401 52.9498 96.0001 53.1098C95.7701 53.2698 95.9201 55.0998 96.0001 55.1098Z",
				fill: "#00DEFF",
				fillOpacity: .4
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M205 61.1098C212.01 67.8098 219.37 81.4398 227 88.1098C226.85 87.6598 227 87.1098 227 87.1098C226.43 84.6798 225.28 82.3098 224 80.1098C222.76 77.9698 220.37 75.7798 220 73.1098C242.41 81.3898 248.39 106.98 250 128.11C250 129.11 250 130.11 250 131.11C252.5 142.52 250.74 155.06 248 166.11C245.7 175.38 243.01 186.22 236 194.11C236.26 193.98 238.94 193.46 240 192.11C243.33 183.07 248.35 173.57 252 165.11C257.86 130.48 248.25 94.3198 233 71.1098C223.5 63.4298 212.42 60.4398 203 54.1098C202.04 50.9098 204.96 60.6998 205 61.1098Z",
				fill: "#1879FD",
				fillOpacity: .54
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M83 59.1098C81.74 59.8698 80.42 61.5098 79 62.1098C79.88 66.5798 84.93 58.8598 86 58.1098C84.68 58.2398 84.17 58.7698 83 59.1098Z",
				fill: "#00B2BB",
				fillOpacity: .07
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.9999 63.1098C9.24994 76.7598 7.02994 93.8298 8.99994 110.11C8.65994 93.0398 11.5099 85.1598 19.9999 74.1098C22.3299 69.9498 24.2499 64.7798 25.9999 60.1098C24.4799 62.0698 20.5199 61.9198 18.9999 63.1098Z",
				fill: "#0B89FF",
				fillOpacity: .67
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M131 61.1098C133.32 62.2298 135.66 63.2798 138 64.1098C148.34 67.7798 165.4 75.4698 173.23 82.8798C181.06 90.2898 201.57 95.3798 205 106.11C205 104.78 205 103.44 205 102.11C201.71 92.1498 180.92 85.5898 172.78 79.3298C164.63 73.0798 145.91 64.4798 136 61.1098C134.37 60.7598 131.67 61.2398 131 61.1098Z",
				fill: "#00E2FF",
				fillOpacity: .17
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M205 61.1098C205.05 61.5998 205 62.6098 205 63.1098C213.1 73.5798 222.99 83.3198 229 95.1098C228.38 92.7598 227.75 90.4498 227 88.1098C219.37 81.4398 212.01 67.8098 205 61.1098Z",
				fill: "#1B77FF",
				fillOpacity: .42
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M205 102.11C205 100.11 205 98.1098 205 96.1098C205 94.4398 205 92.7798 205 91.1098C203.18 91.0798 191.29 76.9898 189 75.1098C190.57 79.6098 191.08 84.4398 192 89.1098C174.46 78.6898 156.15 65.4898 136 61.1098C145.91 64.4798 164.63 73.0798 172.78 79.3298C180.92 85.5898 201.71 92.1498 205 102.11Z",
				fill: "#00DEFF",
				fillOpacity: .25
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M189 75.1098C191.29 76.9898 203.18 91.0798 205 91.1098C205 90.6098 205 89.6098 205 89.1098C205 87.7798 205 86.4398 205 85.1098C195.9 81.3098 189.65 69.7298 181 65.1098C177.68 66.7498 174.96 61.0998 171 62.1098C178 64.9598 183.1 70.2698 189 75.1098Z",
				fill: "#06C8FF",
				fillOpacity: .34
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.9999 102.11C27.2599 107.39 25.9699 105.79 29.9999 110.11C29.5899 106.24 39.2999 100.35 41.9999 98.1098C48.2099 89.8398 76.8699 69.8998 77.9999 63.1098C61.9099 68.8498 38.3999 87.4898 27.9999 102.11Z",
				fill: "#00D3FD",
				fillOpacity: .17
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M205 80.1098C205 81.4398 205 82.7798 205 84.1098C213.05 87.1498 224.21 116.45 228 123.11C228.29 123.61 229.8 124.64 230 125.11C229.99 124.61 230.11 123.58 230 123.11C228.28 115.67 230.59 108.08 230 100.11C229.85 98.0598 229.49 96.9698 229 95.1098C222.99 83.3198 213.1 73.5798 205 63.1098C205 68.7798 205 74.4398 205 80.1098Z",
				fill: "#1C77FF",
				fillOpacity: .33
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M183 93.1098C190.2 97.4698 198.03 107.72 204 108.11C204.11 109.11 203.53 110.84 205 111.11C205.11 109.46 205 107.76 205 106.11C201.57 95.3798 181.06 90.2898 173.23 82.8798C165.4 75.4698 148.34 67.7798 138 64.1098C153.69 72.3098 167.85 83.9198 183 93.1098Z",
				fill: "#00D7FB",
				fillOpacity: .07
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.99996 110.11C9.18996 119.42 15.97 128.36 15 137.11C19.67 150.26 30.5 154.48 40 160.11C35.71 155.82 33.34 149.74 29 146.11C8.35996 128.82 6.45996 102.88 18 82.1098C18.21 80.2698 19.26 76.2898 20 74.1098C11.51 85.1598 8.65996 93.0398 8.99996 110.11Z",
				fill: "#1681FF",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M224 80.1098C240.06 94.8798 244.93 105.03 250 128.11C248.39 106.98 242.41 81.3898 220 73.1098C220.37 75.7798 222.76 77.9698 224 80.1098Z",
				fill: "#1A7BFF",
				fillOpacity: .76
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M224 80.1098C225.28 82.3098 226.43 84.6798 227 87.1098C229.65 88.3698 231.74 95.6298 233 98.1098C233.27 96.4198 247.58 110.45 245 119.11C242.41 127.77 252.05 142.81 243 151.11C240.17 147.84 243.86 141.31 241 138.11C241.27 145.14 240.76 152.85 240 159.11C239.92 162.96 239.73 166.42 239 170.11C247.14 160.83 250 149.12 250 131.11C250 130.11 250 129.11 250 128.11C244.93 105.03 240.06 94.8798 224 80.1098Z",
				fill: "#1582FF",
				fillOpacity: .85
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.9999 146.11C28.7799 145.75 29.2399 144.41 28.9999 144.11C17.0599 129.3 16.2399 106.32 17.9999 88.1098C17.9999 86.1498 17.7799 84.0498 17.9999 82.1098C6.45991 102.88 8.35991 128.82 28.9999 146.11Z",
				fill: "#1582FF",
				fillOpacity: .91
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M205 85.1098C205 86.4398 205 87.7798 205 89.1098C208.42 99.5898 225.21 116.48 225 126.11C225.29 125.88 227.36 127.93 228 127.11C228 125.78 228 124.44 228 123.11C224.21 116.45 213.05 87.1498 205 84.1098C205 84.1098 205 84.6098 205 85.1098Z",
				fill: "#1A7AFF",
				fillOpacity: .21
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M227 88.1098C227.75 90.4498 228.38 92.7598 229 95.1098C229.49 96.9698 229.85 98.0598 230 100.11C231.72 107.06 231.01 114.48 232 122.11C235.32 147.65 244.92 176.84 225 201.11C228.58 198.43 232.2 196.43 236 194.11C243.01 186.22 245.7 175.38 248 166.11C245.9 171.16 240 176.18 236 180.11C237 176 238.15 173.4 239 170.11C239.73 166.42 239.92 162.96 240 159.11C240.42 138.28 235.36 120.04 233 100.11C232.94 99.6198 233.2 98.5098 233 98.1098C231.74 95.6298 229.65 88.3698 227 87.1098C227 87.1098 226.85 87.6598 227 88.1098Z",
				fill: "#0792FF",
				fillOpacity: .6
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.0001 144.11C23.8001 136.37 21.9101 123.63 23.0001 114.11C21.2101 105.47 18.0001 98.0598 18.0001 88.1098C16.2401 106.32 17.0601 129.3 29.0001 144.11Z",
				fill: "#098CFF",
				fillOpacity: .69
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M205 91.1098C205 92.7798 205 94.4398 205 96.1098C214.51 104 210.75 122.16 222 127.11C221.37 128.1 221.27 129.03 221 130.11C221.59 129.72 224.95 129.19 225 129.11C224.81 128.24 224.98 127 225 126.11C225.21 116.48 208.42 99.5898 205 89.1098C205 89.6098 205 90.6098 205 91.1098Z",
				fill: "#1374FD",
				fillOpacity: .09
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 109.11C6 109.11 7 109.15 7 109.11C7 103.11 7 97.1098 7 91.1098C7 91.1098 6.5 91.1098 6 91.1098V109.11Z",
				fill: "#1660FC",
				fillOpacity: .02
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M205 111.11C203.53 110.84 204.11 109.11 204 108.11C198.03 107.72 190.2 97.4698 183 93.1098C189.1 101.06 199.19 106 204 115.11C205.63 114.6 204.91 112.4 205 111.11Z",
				fill: "#00C0FF",
				fillOpacity: .03
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M233 98.1098C233.2 98.5098 232.94 99.6198 233 100.11C239.55 109.76 240.55 126.31 241 138.11C243.86 141.31 240.17 147.84 243 151.11C252.05 142.81 242.41 127.77 245 119.11C247.58 110.45 233.27 96.4198 233 98.1098Z",
				fill: "#1583FF",
				fillOpacity: .95
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.9999 110.11C30.3199 110.45 30.4899 111.86 30.9999 112.11C31.4999 112.11 31.9999 112.11 31.9999 112.11C32.2599 111.99 32.7399 111.36 32.9999 111.11C36.4299 107.83 38.9799 102.14 41.9999 98.1098C39.2999 100.35 29.5899 106.24 29.9999 110.11Z",
				fill: "#00BBFF",
				fillOpacity: .06
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M230 123.11C230.17 122.7 231.88 122.37 232 122.11C231.01 114.48 231.72 107.06 230 100.11C230.59 108.08 228.28 115.67 230 123.11Z",
				fill: "#1782FF",
				fillOpacity: .43
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M240 159.11C240.76 152.85 241.27 145.14 241 138.11C240.55 126.31 239.55 109.76 233 100.11C235.36 120.04 240.42 138.28 240 159.11Z",
				fill: "#068DFF",
				fillOpacity: .76
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.9999 114.11C21.9099 123.63 23.7999 136.37 28.9999 144.11C37.8899 157.33 57.3199 169.59 66.9999 177.11C67.2099 177.27 72.2999 178 70.9999 180.11C73.5899 179.48 73.6499 177.27 76.9999 178.11C76.9199 177.76 76.3299 177.28 75.9999 177.11C56.7799 166.92 18.7499 140.88 27.9999 114.11C28.1499 113.66 28.1999 112.51 27.9999 112.11C27.1699 110.49 25.1099 109.61 23.9999 108.11C24.3799 110.4 23.1799 112.54 22.9999 114.11Z",
				fill: "#1685FF",
				fillOpacity: .4
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31.9999 112.11C30.0099 115.22 33.1399 116.75 35.9999 117.11C40.2799 140.95 60.4799 162.24 83.9999 168.11C83.9999 170.65 86.5999 172.37 85.9999 175.11C83.5399 175.77 80.2799 176.66 78.9999 179.11C78.9799 179.23 79.9199 179.76 79.9999 180.11C80.9099 179.84 82.0699 180.29 82.9999 180.11C85.6899 178.76 88.3099 177.48 90.9999 176.11C74.6999 157.69 39.0599 146.22 37.9999 114.11C35.5799 114.53 34.4599 112.21 32.9999 111.11C32.7399 111.36 32.2599 111.99 31.9999 112.11Z",
				fill: "#1077FD",
				fillOpacity: .06
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28 114.11C42.74 135.25 54.37 163.69 82 173.11C80.26 175.04 76 174.01 76 177.11C76.33 177.28 76.92 177.76 77 178.11C77.12 178.66 78.95 179.48 79 179.11C80.28 176.66 83.54 175.77 86 175.11C86.6 172.37 84 170.65 84 168.11C60.48 162.24 40.28 140.95 36 117.11C33.14 116.75 30.01 115.22 32 112.11C32 112.11 31.5 112.11 31 112.11C30.21 112.11 28.74 112.37 28 112.11C28.2 112.51 28.15 113.66 28 114.11Z",
				fill: "#1B79FF",
				fillOpacity: .17
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M76 177.11C76 174.01 80.26 175.04 82 173.11C54.37 163.69 42.74 135.25 28 114.11C18.75 140.88 56.78 166.92 76 177.11Z",
				fill: "#1C76FE",
				fillOpacity: .3
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M230 123.11C230.11 123.58 229.99 124.61 230 125.11C230.37 139.21 242.91 155.28 235.01 170.12C227.11 184.96 228.22 195.99 218 209.11C219 209.11 220 209.11 221 209.11C224.94 208.71 236.59 198.95 239 195.11C239.36 194.3 239.66 193.03 240 192.11C238.94 193.46 236.26 193.98 236 194.11C232.2 196.43 228.58 198.43 225 201.11C244.92 176.84 235.32 147.65 232 122.11C231.88 122.37 230.17 122.7 230 123.11Z",
				fill: "#00A9FF",
				fillOpacity: .46
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M225 126.11C224.98 127 224.81 128.24 225 129.11C225.15 129.81 226.54 131.65 227 132.11C227.78 132.89 229.26 133.39 230 134.11C240.4 144.24 227.15 167.83 226.6 179.86C226.05 191.88 210.77 202.81 205 216.11C208.61 213.79 216.68 213.49 221 212.11C222.22 211.38 224.28 209.97 224 208.11C223.06 208.68 222.18 209.26 221 209.11C220 209.11 219 209.11 218 209.11C228.22 195.99 227.11 184.96 235.01 170.12C242.91 155.28 230.37 139.21 230 125.11C229.8 124.64 228.29 123.61 228 123.11C228 124.44 228 125.78 228 127.11C227.36 127.93 225.29 125.88 225 126.11Z",
				fill: "#00BCFF",
				fillOpacity: .36
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M221 130.11C204.64 140.93 190.76 169.79 174 184.11C181.69 179.84 194.46 166.36 202.75 161.86C211.05 157.37 221.04 131.94 227 132.11C226.54 131.65 225.15 129.81 225 129.11C224.95 129.19 221.59 129.72 221 130.11Z",
				fill: "#00CFFE",
				fillOpacity: .11
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M239 170.11C238.15 173.4 237 176 236 180.11C240 176.18 245.9 171.16 248 166.11C250.74 155.06 252.5 142.52 250 131.11C250 149.12 247.14 160.83 239 170.11Z",
				fill: "#1085FF",
				fillOpacity: .76
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M174 184.11C170.88 186.78 168.5 187.63 166 190.11C165.41 190.7 164.65 191.59 164 192.11C165.81 192.01 167.39 190.9 169 190.11C191.71 176.17 215.6 157.46 230 134.11C229.26 133.39 227.78 132.89 227 132.11C221.04 131.94 211.05 157.37 202.75 161.86C194.46 166.36 181.69 179.84 174 184.11Z",
				fill: "#00D5FF",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M169 190.11C185.12 182.21 200.18 172.79 214 161.11C206.68 186.17 190.7 221.02 157 217.11C166.56 218.04 177.72 218.5 188 218.11C187.53 219.89 179.41 218.71 184 220.11C190.1 219.12 198.66 221.55 204 218.11C204.42 217.42 204.68 216.84 205 216.11C210.77 202.81 226.05 191.88 226.6 179.86C227.15 167.83 240.4 144.24 230 134.11C215.6 157.46 191.71 176.17 169 190.11Z",
				fill: "#00D0FF",
				fillOpacity: .38
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14 140.11C14.22 140.69 14.93 141.56 15 142.11C14.52 141.49 16.43 143.13 17 144.11C19.36 148.18 21.44 152.15 24 156.11C30.54 162.27 41.08 170.36 50 169.11C46.83 166.32 43.46 162.81 40 160.11C30.5 154.48 19.67 150.26 15 137.11C14.87 138.32 14.16 139.06 14 140.11Z",
				fill: "#1589FF",
				fillOpacity: .67
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.9999 142.11C16.6099 155.67 14.9999 170.44 14.9999 184.11C16.7999 202.7 35.3199 231.59 51.2999 242.81C67.2699 254.03 98.4499 248.92 118.25 233.31C138.04 217.7 172.24 228.75 197 226.11C200.36 224.76 204.14 222.96 208 222.11C207.6 222.01 204.48 218.08 202 220.11C201.91 218.72 206.19 219.39 204 218.11C198.66 221.55 190.1 219.12 184 220.11C169.29 222.5 153.58 217.42 138 220.11C111.68 228.21 86.8099 246.75 57.9999 246.11C30.3499 220.63 8.33995 183.79 16.9999 144.11C16.4299 143.13 14.5199 141.49 14.9999 142.11Z",
				fill: "#00DCFF",
				fillOpacity: .18
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M138 220.11C118.42 223.48 97.4299 241.31 78.9999 231.11C77.7499 228.4 75.7299 227.19 74.9999 224.11C67.6099 225.79 66.9499 216.16 59.9999 214.11C61.7499 209.72 57.5899 206.02 52.9999 205.11C49.2699 195.96 43.9999 185.5 39.9999 174.11C39.8199 173.69 39.2599 172.4 38.9999 172.11C32.5899 168.5 27.8799 162.12 23.9999 156.11C21.4399 152.15 19.3599 148.18 16.9999 144.11C8.33989 183.79 30.3499 220.63 57.9999 246.11C86.8099 246.75 111.68 228.21 138 220.11Z",
				fill: "#00E0FF",
				fillOpacity: .25
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29 146.11C33.34 149.74 35.71 155.82 40 160.11C43.46 162.81 46.83 166.32 50 169.11C41.08 170.36 30.54 162.27 24 156.11C27.88 162.12 32.59 168.5 39 172.11C48.9 177.68 57.39 176 67 177.11C57.32 169.59 37.89 157.33 29 144.11C29.24 144.41 28.78 145.75 29 146.11Z",
				fill: "#1297FF",
				fillOpacity: .54
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M169 190.11C167.39 190.9 165.81 192.01 164 192.11C173.84 188.96 186.8 185.18 197 179.11C189.24 195.24 173.39 212.05 155 214.11C154.5 214.06 154 214.11 154 214.11C131.1 226.63 97.64 212.75 82 194.11C94.18 196.69 107.97 200.76 120 199.11C118.04 198.42 115.87 197.88 114 197.11C100.38 195.92 85.55 193.37 72 188.11C85.82 211.45 114.12 227.82 141 218.11C146.52 218 151.39 217.11 157 217.11C190.7 221.02 206.68 186.17 214 161.11C200.18 172.79 185.12 182.21 169 190.11Z",
				fill: "#00DEFF",
				fillOpacity: .49
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M240 192.11C239.66 193.03 239.36 194.3 239 195.11C238.22 196.85 236.91 198.43 236 200.11C239.67 194.75 245.19 188.15 248 183.11C249.94 177.29 250.98 171.15 252 165.11C248.35 173.57 243.33 183.07 240 192.11Z",
				fill: "#1180FE",
				fillOpacity: .34
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40 174.11C46.36 179.12 60.48 183.31 69 181.11C69.32 181.03 70.3 180.28 71 180.11C72.3 178 67.21 177.27 67 177.11C57.39 176 48.9 177.68 39 172.11C39.26 172.4 39.82 173.69 40 174.11Z",
				fill: "#0AB9FF",
				fillOpacity: .45
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M138 220.11C153.58 217.42 169.29 222.5 184 220.11C179.41 218.71 187.53 219.89 188 218.11C177.72 218.5 166.56 218.04 157 217.11C151.39 217.11 146.52 218 141 218.11C106.8 222.24 74.76 222.02 63 183.11C66 183.11 69 183.11 72 183.11C71.37 182.76 69.61 181.27 69 181.11C60.48 183.31 46.36 179.12 40 174.11C44 185.5 49.27 195.96 53 205.11C57.59 206.02 61.75 209.72 60 214.11C66.95 216.16 67.61 225.79 75 224.11C75.73 227.19 77.75 228.4 79 231.11C97.43 241.31 118.42 223.48 138 220.11Z",
				fill: "#00E1FF",
				fillOpacity: .34
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M71 180.11C70.3 180.28 69.32 181.03 69 181.11C69.61 181.27 71.37 182.76 72 183.11C72.5 183.11 73 183.11 73 183.11C75.04 182.3 76.89 181.8 79 181.11C79.25 181.03 79.65 180.22 80 180.11C79.92 179.76 78.98 179.23 79 179.11C78.95 179.48 77.12 178.66 77 178.11C73.65 177.27 73.59 179.48 71 180.11Z",
				fill: "#07C0FE",
				fillOpacity: .28
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M164 192.11C163.13 192.8 162.03 193.73 161 194.11C161 194.11 160.4 193.91 160 194.11C159.52 194.35 159.33 195.89 159 196.11C169.53 193.37 179.93 190.38 190 186.11C183.04 199.97 167.83 207.72 155 214.11C173.39 212.05 189.24 195.24 197 179.11C186.8 185.18 173.84 188.96 164 192.11Z",
				fill: "#00DFFE",
				fillOpacity: .6
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M79 181.11C79.95 186.08 98.79 190.76 103 192.11C96.76 189.03 89.49 182.31 83 180.11C82.07 180.29 80.91 179.84 80 180.11C79.65 180.22 79.25 181.03 79 181.11Z",
				fill: "#00E0FB",
				fillOpacity: .09
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M73 183.11C81.51 190.41 100.52 193.4 110 195.11C107.66 193.91 105.44 192.89 103 192.11C98.79 190.76 79.95 186.08 79 181.11C76.89 181.8 75.04 182.3 73 183.11Z",
				fill: "#00E2FE",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M141 218.11C114.12 227.82 85.82 211.45 72 188.11C85.55 193.37 100.38 195.92 114 197.11C112.61 196.54 111.35 195.8 110 195.11C100.52 193.4 81.51 190.41 73 183.11C73 183.11 72.5 183.11 72 183.11C69 183.11 66 183.11 63 183.11C74.76 222.02 106.8 222.24 141 218.11Z",
				fill: "#00E3FE",
				fillOpacity: .42
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M236 200.11C235.27 201.45 234.67 202.75 234 204.11C233.1 205.92 232.39 208.45 231 210.11C231.45 209.96 232.63 210.33 233 210.11C239.27 202.16 244.81 192.68 248 183.11C245.19 188.15 239.67 194.75 236 200.11Z",
				fill: "#0385FF",
				fillOpacity: .15
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M63 257.11C66.31 257.03 72.2 253.78 76 253.11C83.12 251.85 89.65 248.72 96 246.11C98.01 244.69 100.34 243.72 103 243.11C114.99 237.18 129.92 226.18 142.78 222.89C155.63 219.6 177.3 231.5 192 230.11C189.55 227.23 195.6 226.67 197 226.11C172.24 228.75 138.04 217.7 118.25 233.31C98.45 248.92 67.27 254.03 51.3 242.81C35.32 231.59 16.8 202.7 15 184.11C15 197.9 21.71 219.49 32.08 228.03C42.46 236.56 48.8 257.46 63 257.11Z",
				fill: "#00D5F9",
				fillOpacity: .07
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M159 196.11C156.82 196.68 154.91 197.94 153 197.11C153 197.11 153.13 198.07 153 198.11C158.13 203.42 175.5 192.1 182 193.11C178.72 198.05 173.7 201.05 169 204.11C152.28 214.46 133.88 218.08 115 211.11C109.98 209.26 105 207.08 100 205.11C112.68 201.13 131.39 206.88 142 200.11C135.86 201.19 129.22 201.52 123 200.11C113.03 200.54 100.6 200.03 91 200.11C108.21 214.75 132.04 219.03 154 214.11C154 214.11 154.5 214.06 155 214.11C167.83 207.72 183.04 199.97 190 186.11C179.93 190.38 169.53 193.37 159 196.11Z",
				fill: "#00E1FE",
				fillOpacity: .69
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M153 197.11C154.91 197.94 156.82 196.68 159 196.11C159.33 195.89 159.52 194.35 160 194.11C158.26 193.04 154.07 196.35 153 197.11Z",
				fill: "#00BDC3",
				fillOpacity: .04
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M153 198.11C149.39 199.15 145.69 199.46 142 200.11C131.39 206.88 112.68 201.13 100 205.11C105 207.08 109.98 209.26 115 211.11C130 209.86 153.31 206.47 169 204.11C173.7 201.05 178.72 198.05 182 193.11C175.5 192.1 158.13 203.42 153 198.11Z",
				fill: "#00E3FF",
				fillOpacity: .82
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M154 214.11C132.04 219.03 108.21 214.75 91 200.11C100.6 200.03 113.03 200.54 123 200.11C122.08 199.9 120.85 199.41 120 199.11C107.97 200.76 94.18 196.69 82 194.11C97.64 212.75 131.1 226.63 154 214.11Z",
				fill: "#00E3FF",
				fillOpacity: .61
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M221 209.11C222.18 209.26 223.06 208.68 224 208.11C224.28 209.97 222.22 211.38 221 212.11C225.47 210.68 230.96 208.08 234 204.11C234.67 202.75 235.27 201.45 236 200.11C236.91 198.43 238.22 196.85 239 195.11C236.59 198.95 224.94 208.71 221 209.11Z",
				fill: "#00A1FF",
				fillOpacity: .36
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M115 211.11C133.88 218.08 152.28 214.46 169 204.11C153.31 206.47 130 209.86 115 211.11Z",
				fill: "#00E3FF",
				fillOpacity: .96
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M221 212.11C216.68 213.49 208.61 213.79 205 216.11C204.68 216.84 204.42 217.42 204 218.11C206.19 219.39 201.91 218.72 202 220.11C204.48 218.08 207.6 222.01 208 222.11C216.61 220.2 222.32 213.1 231 210.11C232.39 208.45 233.1 205.92 234 204.11C230.96 208.08 225.47 210.68 221 212.11Z",
				fill: "#00B4FF",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M208 222.11C204.14 222.96 200.36 224.76 197 226.11C195.6 226.67 189.55 227.23 192 230.11C192 230.11 192.51 230.05 193 230.11C194.4 228.76 196.01 229.26 198 229.11C212.53 228.05 223.4 222.27 233 210.11C232.63 210.33 231.45 209.96 231 210.11C222.32 213.1 216.61 220.2 208 222.11Z",
				fill: "#00B4FB",
				fillOpacity: .07
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M96 246.11C98.4 245.12 100.76 244.22 103 243.11C100.34 243.72 98.01 244.69 96 246.11Z",
				fill: "#00D0D6",
				fillOpacity: .02
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M63 257.11C67.21 257.36 72.42 254.27 76 253.11C72.2 253.78 66.31 257.03 63 257.11Z",
				fill: "#00FFFF",
				fillOpacity: .01
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_f_3699_717",
		x: 0,
		y: -5.8902,
		width: 260,
		height: 281,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "BackgroundImageFix",
				result: "shape"
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				stdDeviation: 3,
				result: "effect1_foregroundBlur_3699_717"
			})
		]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3699_717",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 248,
			height: 269,
			fill: "white",
			transform: "translate(6 0.109802)"
		})
	})] })]
});
export default SvgNebulaUser;
